/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import React, { useEffect } from "react";
import { useAppointment } from "@/context/appointment";
import { BUTTONTYPE } from "@/types/button-type";
import { VARIANT } from "@/types/variant";
import { Box, Stack, useMediaQuery } from "@mui/material";
import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { useSearchParams } from "next/navigation";
import Cookies from 'js-cookie';
const SelectTime = dynamic(() => import('@/components/pages/consultation/select-time'), { ssr: false });
const Details = dynamic(() => import('@/components/pages/consultation/details'), { ssr: false });
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });
const Button = dynamic(() => import('@/components/common/button'), { ssr: false });

import '@/components/styles/consultation/choose_advisor.css';
import ChooseAdvisor from "@/components/pages/consultation/choose-advisor";
import {useAuth} from "@/context/with-auth";

export default function Page() {
    const [lang, setLang] = React.useState('en');
    const [type, setType] = React.useState('group');
    const router = useRouter();
    const is_mobile = useMediaQuery('(max-width:1024px)');
    const { formik, loading, GetDefaultSchedule, setCalenderType } = useAppointment();
    const t = useTranslations('consultation');
    const searchParams = useSearchParams();
    const { user } = useAuth();

    const heroSection = t.raw(`heroSection_${type}`);

    useEffect(() => {
        const sp = searchParams as any;
        if (!sp) return;
        const typeParam = sp.get('type') || 'group';
        if (typeParam) {
            setType(typeParam);
        }

        const lang = Cookies.get('language') || 'en';
        setLang(lang);

        if (lang === 'fa') {
            setCalenderType('persian');
        } else {
            setCalenderType('gregorian');
        }

        const parts: string[] = [];
        parts.push(`type=${encodeURIComponent(typeParam)}`);
        if (lang) parts.push(`locale=${encodeURIComponent(lang)}`);
        const extra = parts.length ? `&${parts.join('&')}` : '';

        GetDefaultSchedule(extra);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            backgroundColor: 'white',
          }}
          width={'100%'}
          paddingY={{ lg: 6, md: 5, sm: 5, xs: 5 }}
          paddingX={{ lg: 5, md: 3, sm: 3, xs: 3 }}
          borderRadius={'12px'}
        >
            {
                user ?
                    <ChooseAdvisor/>
                    :
                    <Stack
                        useFlexGap
                        spacing={4}
                        direction={'column'}
                        className={'Choose_advisor_secTop hero-section'}
                    >
                        <div className="hero-top">
                            <Image alt="img_hero" className="hero-image" url="/consultation/img_hero.png" />
                        </div>
                        <div className={`hero-middle ${lang}`}>{heroSection.headline}</div>
                        <div className={`hero-btm ${lang}`}>
                            <p>{heroSection.subheading}</p>
                            {lang=='en'?<p>{heroSection.subheading_p2}</p>:''}
                        </div>
                    </Stack>
            }
          <Stack
            useFlexGap
            spacing={4}
            direction={'column'}
          >
            <Image
              alt="divider"
              url="/divider.svg"
              className="w-full"
            />

            <SelectTime />
            <Details />
          </Stack>

          <Stack
            direction={{ lg: 'row', md: 'column-reverse', xs: 'column-reverse', sm: 'column-reverse' }}
            spacing={'10px'}
            useFlexGap
            justifyContent={'end'}
            paddingRight={{ lg: 5 }}
            marginTop={{ md: 4, sm: 4, xs: 4 }}
          >
            <Button
              disabled={loading}
              aria_label="back button"
              text={t('detail_card.cancel_btn')}
              handleClick={() => { router.replace('/consultation') }}
              type={BUTTONTYPE.BUTTON}
              key={'back button'}
              variant={VARIANT.OUTLINED}
              font={!is_mobile ? 15 : undefined}
              borderRadius={!is_mobile ? 12 : undefined}
              className="w-full lg:w-fit"
            />
            <Button
              loading={loading}
              aria_label="book button"
              text={t('detail_card.submit_btn')}
              handleClick={() => { }}
              type={BUTTONTYPE.SUBMIT}
              key={'book button'}
              variant={VARIANT.CONTAINED}
              font={!is_mobile ? 15 : undefined}
              borderRadius={!is_mobile ? 12 : undefined}
              className="w-full lg:w-fit"
            />
          </Stack>

        </Box>
      </form>
};
